<template>
  <div class="screen-root safe-area" ref="root" :class="{ scrollable: isScrollable || scrollable }">
    <div v-if="showIntro" class="intro-text">
      {{ introText || screenName }}
    </div>
    <template v-else>
      <div
        class="screen-titles"
        :class="{ invisible: blank && !error, 'justify-center': centerTitles }"
      >
        <img v-if="error" class="error-icon" src="../../assets/common/error.png" alt="Error" />
        <h2
          class="screen-name"
          :class="{ 'text-center': centerTitles, 'text-purple-gradient': purpleTitle }"
        >
          {{ screenName }}
        </h2>
        <div v-if="step" class="step-wrapper">
          <h1 class="step">{{ step }}</h1>
          <h1 class="screen-info" :class="{ error }" v-html="screenInfo"></h1>
        </div>
        <h1 v-else class="screen-info" :class="{ error }" v-html="screenInfo"></h1>
      </div>
      <div
        class="content-container"
        ref="content"
        :class="{ 'no-padding': noPadding, '-mb-20': isScrollable }"
      >
        <slot></slot>
      </div>
      <p class="alt-info" v-html="altInfo"></p>
    </template>
    <div class="left-btn absolute" v-if="canSkip && !showIntro">
      <span @click="$emit('skip')">{{ skipText || $t('scanscreen.skip') }}</span>
    </div>
    <div class="right-btn absolute p-3" v-if="canLeave && !showIntro">
      <img src="../../assets/common/close-icon.svg" @click="$emit('leave')" alt="Leave" />
    </div>
    <slot name="audio"></slot>
  </div>
</template>

<script>
import scanScreen from '@/mixins/scan-screen';

export default {
  name: 'Screen',
  mixins: [scanScreen],
  data: () => ({
    isScrollable: false,
  }),
  mounted() {
    this.checkIfLastElementIsOutOfRoot();
    window.addEventListener('resize', this.checkIfLastElementIsOutOfRoot);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.checkIfLastElementIsOutOfRoot);
  },
  methods: {
    checkIfLastElementIsOutOfRoot() {
      if (!this.$refs.content) return;

      const lastElement = this.$refs.content.lastElementChild;
      if (!lastElement) return;

      const lastElementBottom = lastElement.getBoundingClientRect().bottom;
      const rootBottom = this.$refs.root.getBoundingClientRect().bottom;
      this.isScrollable = lastElementBottom > rootBottom;
    },
  },
};
</script>

<style lang="scss" scoped>
.screen-root {
  @apply flex-col w-full h-full flex items-center;
  &.scrollable {
    @apply pb-0 overflow-y-auto;
    @screen tall {
      @apply pb-20 overflow-y-hidden;
    }
  }
}
.screen-titles {
  @apply flex relative flex-col w-full text-left h-40 mt-16 px-8;
  @screen sm {
    @apply mt-20 px-20;
  }
  @screen md {
    @apply h-64;
  }
  @screen lg {
    @apply mt-24 px-24;
  }
  .error-icon {
    @apply absolute mx-auto;
    width: 5%;
    left: 0;
    right: 0;
    top: -15%;
  }
}
.screen-name {
  @apply text-2xl;
  font-weight: 500;
  line-height: 1.25;
  color: #5b5b5b;
  @screen xs {
    @apply text-lg;
  }
  @screen lg {
    @apply text-4xl;
  }
}
.step-wrapper {
  @apply flex flex-row mt-2;
  .screen-info {
    @apply text-left text-base font-semibold;
    line-height: 20px;
  }
}
.step {
  @apply text-xl text-center mt-5 mx-5;
  font-size: 70px;
  line-height: 60px;
}
.screen-info {
  @apply text-xl text-center mt-5;
  font-weight: bold;
  line-height: 1.5;
  color: #2c2c2c;
  min-height: 6rem;
  @screen sm {
    @apply text-4xl;
  }
  @screen lg {
    @apply text-5xl;
  }
  &.error {
    @apply font-bold;
    color: #b32223;
  }
}
.intro-text {
  @apply mx-auto text-center flex flex-1 flex-col justify-center overflow-visible w-full pt-10;
  font-size: 33px;
}
.content-container {
  @apply flex flex-1 flex-col items-center overflow-visible w-full px-6 py-4;
  @screen sm {
    @apply px-20;
  }
  @screen tall {
    @apply pt-8 pb-20;
  }
  &.no-padding {
    padding: 0 !important;
  }
}
.skip-btn {
  @apply absolute top-0 left-0 mt-10 ml-12 cursor-pointer;
  color: rgba(38, 38, 38, 0.4);

  @screen xs {
    @apply mt-4 ml-5;
    margin-top: calc(constant(safe-area-inset-top, -1rem) + 1rem);
    margin-top: calc(env(safe-area-inset-top, -1rem) + 1rem);
  }
}
.alt-info {
  @apply mb-32 text-center;
  font-size: 18px;
  max-width: 70%;
  @screen lg {
    @apply mb-56;
    font-size: 24px;
  }
}

.right-btn {
  top: 5vh;
  right: 1.75rem;
}

.left-btn {
  color: rgba(38, 38, 38, 0.4);
  @extend .right-btn;
  left: 1.75rem;
  transform: translateY(25%);
}
</style>
